import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'

export const userSubOrderDocumentPositionAccessorGetTotalPrice = (
  documentPosition: UserDocumentPosition | UserDocumentPositionERx,
): number | undefined => {
  const { quantity, salesPrice } = documentPosition

  if (typeof salesPrice !== 'number' || Number.isNaN(salesPrice)) {
    return undefined
  }

  const safeQuantity =
    typeof quantity === 'number' && quantity > 0 ? quantity : 1

  return salesPrice * safeQuantity
}
